import React from 'react';
import dynamic from 'next/dynamic';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebaseApp';
import CookieBanner from './CookieBanner';

// No placeholder text while these load: a "Loading..." line flashed on first load and shifted the page when the
// fixed header replaced it.
const Header = dynamic(() => import('./Header/Header'), {
  loading: () => null,
  ssr: false,
  priority: true
});

const Footer = dynamic(() => import('./Header/Footer'), {
  loading: () => null,
  ssr: false,
  priority: false
});

const Layout = ({ provider, children }) => {
  const user = useAuthState(auth);

  return(
    <>
      <Header user={user[0]} auth={auth} provider={provider}/>
      {children}
      <div className="bg-black pb-10"><Footer /></div>
      <CookieBanner />
    </>
  );
};

export default Layout;
